import {StandingsWidgetFilterViewModel} from "./standings-widget.filter.view-model";

export class StandingsWidgetFilterGroupCategoryViewModel extends StandingsWidgetFilterViewModel {
  get type(): Number {
    return this.entity.num;
  }

  get name(): String {
    return this.entity.name;
  }
}
